
import React from "react";
import { Link, useParams } from "react-router-dom";
import { BlogCategory } from "@/types/blog";
import { cn } from "@/lib/utils";

interface BlogCategoryFilterProps {
  categories: BlogCategory[];
}

const BlogCategoryFilter: React.FC<BlogCategoryFilterProps> = ({ categories }) => {
  const { categorySlug } = useParams<{ categorySlug: string }>();
  
  return (
    <div className="mb-8 overflow-auto pb-2">
      <div className="flex gap-2 whitespace-nowrap">
        <Link
          to="/blog"
          className={cn(
            "inline-block rounded-full border px-4 py-2 text-sm transition-colors",
            !categorySlug
              ? "border-sauna-blue bg-sauna-blue text-white"
              : "border-border bg-transparent hover:bg-muted"
          )}
        >
          All Posts
        </Link>
        {categories.map((category) => (
          <Link
            key={category.id}
            to={`/blog/category/${category.slug}`}
            className={cn(
              "inline-block rounded-full border px-4 py-2 text-sm transition-colors",
              category.slug === categorySlug
                ? "border-sauna-blue bg-sauna-blue text-white"
                : "border-border bg-transparent hover:bg-muted"
            )}
          >
            {category.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogCategoryFilter;
